import * as React from 'react';
import Dialog from '../../../../../../../BaseComponents/Dialog/EDDialog';
import { kodplaner_ekkodplaner } from '../../../../../../../Components/KodplanManager/Queries/_QueryTypes/kodplaner';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import { KodplanConsumer } from '../../../../../../../Components/KodplanManager/Context/KodplanContext';
import { getKodplanByYear } from '../../../../../../../Model/ModelContext/KodplanUtils';
import { EkonomiskAnalysSelectConsumer } from '../SideMenu/Components/AnalysSelect/Context/EkonomiskAnalysSelectContext';
import { EkonomiskAnalysContextConsumer } from '../Context/EkonomiskAnalysContext';
import Logger from '../../../../../../../Utils/Logger';
import { IEkonomiskAnalysDates } from '../AnalysSettingsHandler/AnalysSettingsHandler';

interface IProps {
  open: boolean;
  onClose: () => void;
  onExited: () => void;
  commitCallback: (() => void) | undefined;
  cancelCallback?: () => void;
  activeKodplan: kodplaner_ekkodplaner | undefined;
  year: number | undefined;
}

class EkonomiskAnalysInvalidYearDialog extends React.Component<IProps> {
  onCancel = () => {
    this.props.onClose();
    if (this.props.cancelCallback) {
      this.props.cancelCallback();
    }
  };

  onAccept =
    (
      setActiveKodplan: (newActiveKodplan: kodplaner_ekkodplaner) => void,
      newActiveKodplan: kodplaner_ekkodplaner | undefined,
      deselectAnalys: () => void,
      setStartDates: (newStartDates: IEkonomiskAnalysDates) => void,
      year: number | undefined
    ) =>
    () => {
      if (this.props.commitCallback && newActiveKodplan != null) {
        setActiveKodplan(newActiveKodplan);
        deselectAnalys();
        /** IS THIS STILL NEEDED? */
        // setStartDates({ fromYear: year });
        this.props.commitCallback();
      } else {
        Logger.error(
          new Error('commitCallback is undefined or newActiveKodplan is null')
        );
      }
      this.props.onClose();
    };

  render() {
    const { open, onClose, onExited, activeKodplan, year } = this.props;

    const activeKodplanNamn =
      activeKodplan && activeKodplan.namn ? activeKodplan.namn : 'Okänt namn';

    return (
      <EkonomiskAnalysContextConsumer>
        {({ setStartDates }) => (
          <EkonomiskAnalysSelectConsumer>
            {({ deselectAnalys }) => (
              <KodplanConsumer>
                {({ availableKodplanList, setActiveKodplan }) => {
                  const validKodplan =
                    year != null
                      ? getKodplanByYear(availableKodplanList, year)
                      : undefined;

                  const validKodplanNamn = validKodplan && validKodplan.namn;
                  const kodplanNamn =
                    validKodplan && validKodplan.namn
                      ? validKodplan.namn
                      : 'Okänt namn';

                  const footerActions = [
                    {
                      label: validKodplanNamn ? 'Nej' : 'Stäng',
                      onClick: this.onCancel,
                    },
                  ];
                  if (validKodplanNamn) {
                    footerActions.push({
                      label: 'Ja',
                      onClick: this.onAccept(
                        setActiveKodplan,
                        validKodplan,
                        deselectAnalys,
                        setStartDates,
                        year
                      ),
                    });
                  }

                  return (
                    <Dialog
                      open={open}
                      title="Ogiltig kodplan"
                      onClose={onClose}
                      footerActions={footerActions}
                      onExited={onExited}
                    >
                      <EDTypography gutterBottom>
                        Den aktiva kodplanen {activeKodplanNamn} är ej giltig
                        för analysåret {year}.
                      </EDTypography>
                      {validKodplanNamn && (
                        <EDTypography>
                          Vill du fortsätta din analys med kodplanen{' '}
                          {kodplanNamn} som är giltig för analysåret {year}?
                        </EDTypography>
                      )}
                      {!validKodplanNamn && (
                        <EDTypography>
                          Ingen lämplig kodplan för året hittades
                        </EDTypography>
                      )}
                    </Dialog>
                  );
                }}
              </KodplanConsumer>
            )}
          </EkonomiskAnalysSelectConsumer>
        )}
      </EkonomiskAnalysContextConsumer>
    );
  }
}

export default EkonomiskAnalysInvalidYearDialog;
